import { useState } from 'react';
import ReactDOM from 'react-dom';
import { Dialog, Button, TextArea } from '@dsi/react-eds';
import ReactEDSWrapper from '../../utils/react-eds-wrapper';
import { PipelineItem } from '../../const/PipelineTypes';

interface DeploymentApprovalDialogProps {
  open: boolean;
  onClose: () => void;
  onApprove: (pipeline: PipelineItem) => void;
  onReject: (pipeline: PipelineItem, reason: string) => void;
  pipeline: PipelineItem;
}

type Decision = 'approve' | 'reject';

function DeploymentApprovalDialog({ open, onClose, onApprove, onReject, pipeline }: DeploymentApprovalDialogProps) {
  const [decision, setDecision] = useState<Decision>('approve');
  const [rejectReason, setRejectReason] = useState('');

  const isSaveDisabled = decision === 'reject' && !rejectReason.trim();

  const handleSave = () => {
    if (decision === 'approve') {
      onApprove(pipeline);
    } else {
      onReject(pipeline, rejectReason.trim());
    }
    onClose();
  };

  if (!open) return null;

  return ReactDOM.createPortal(
    <ReactEDSWrapper
      component={Dialog}
      show={open}
      onClose={onClose}
      title="Deployment Approval"
      subtitle={`Ticket: ${pipeline.TicketId}`}
      bottom={
        <ReactEDSWrapper component={Button} primary onClick={handleSave} disabled={isSaveDisabled}>
          Save
        </ReactEDSWrapper>
      }
    >
      <p style={{ marginBottom: '16px' }}>
        Do you want to proceed with the deployment for this ticket?
      </p>
      <fieldset style={{ marginBottom: '16px', border: 'none', padding: 0 }}>
        <div style={{ marginBottom: '8px' }}>
          <input id="decision-approve" name="decision" type="radio" checked={decision === 'approve'} onChange={() => setDecision('approve')} />
          <label htmlFor="decision-approve">Approve</label>
        </div>
        <div>
          <input id="decision-reject" name="decision" type="radio" checked={decision === 'reject'} onChange={() => setDecision('reject')} />
          <label htmlFor="decision-reject">Reject</label>
        </div>
      </fieldset>
      {decision === 'reject' && (
        <ReactEDSWrapper
          component={TextArea}
          label="Rejection reason"
          placeholder="Required if rejecting..."
          value={rejectReason}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setRejectReason(e.target.value.slice(0, 100))}
          rows={3}
          maxLength={100}
          style={{ width: '80%' }}
        />
      )}
    </ReactEDSWrapper>,
    document.body
  );
}

export default DeploymentApprovalDialog;
